(function () {
  var requestId = 0;

  function refreshCollectionTrustMin() {
    var node = document.querySelector('[data-trust-price]');
    if (!node) return;

    var total = Number(node.getAttribute('data-trust-total') || 0);
    if (total <= 50) return;

    var id = (requestId += 1);
    var pages = Math.ceil(total / 50);
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.set('view', 'trust-prices');

    var jobs = [];
    for (var page = 1; page <= pages; page += 1) {
      params.set('page', String(page));
      jobs.push(
        fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            return null;
          }),
      );
    }

    Promise.all(jobs).then(function (rows) {
      if (id !== requestId) return;
      if (!node.isConnected) return;

      var min = null;
      rows.forEach(function (row) {
        if (!row || row.min == null) return;
        if (min == null || row.min < min) min = row.min;
      });
      if (min == null) return;

      var amount = Math.round(min / 100)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      var title = node.querySelector('.collection-trust__title');
      var previous = node.getAttribute('data-trust-label');
      if (!title || !previous || previous === amount) return;
      title.textContent = title.textContent.replace(previous, amount);
      node.setAttribute('data-trust-label', amount);
    });
  }

  var trustMinObserver = null;

  function scheduleCollectionTrustMin() {
    var node = document.querySelector('[data-collection-trust-section-id]');
    if (!node) return;
    if (trustMinObserver) trustMinObserver.disconnect();
    if (!('IntersectionObserver' in window)) {
      refreshCollectionTrustMin();
      return;
    }
    trustMinObserver = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (entry) {
            return entry.isIntersecting;
          })
        )
          return;
        trustMinObserver.disconnect();
        trustMinObserver = null;
        refreshCollectionTrustMin();
      },
      { rootMargin: '600px 0px' },
    );
    trustMinObserver.observe(node);
  }

  window.refreshCollectionTrustMin = scheduleCollectionTrustMin;
  scheduleCollectionTrustMin();
})();
